import { useSkaldElements } from '@skaldaura/devkit'
import Footer from 'components/footer/footer'
import Headband from 'components/headband/headband'
import Header from 'components/header/header'
import PopupVeille from 'components/popupVeille/popupVeille'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext, { headbandType } from 'contexts/headband'
import LangContext from 'contexts/lang'
import Accueil from 'pages/accueil/accueil'
import AutresInformations from 'pages/salarie/autresInformations/autresInformations'
import BoiteIdee from 'pages/salarie/boiteIdee/boiteIdee'
import HSESalarie from 'pages/salarie/hse/hseSalarie'
import Moulage from 'pages/salarie/moulure/moulage'
import NosClientsNosProduits from 'pages/salarie/nosClientsNosProduits/nosClientsNosProduits'
import Archives from 'pages/salarie/projets/archives'
import Projets from 'pages/salarie/projets/projets'
import Qualité from 'pages/salarie/qualite/qualite'
import SiteNeubourg from 'pages/salarie/siteNeubourg/siteNeubourg'
import Urgence from 'pages/salarie/urgence/urgence'
import VosInformationsRH from 'pages/salarie/vosInformationsRH/vosInformationsRH'
import Environnement from 'pages/visiteur/environnement/environnement'
import GammeProduits from 'pages/visiteur/gamme/gammeProduits'
import Groupe from 'pages/visiteur/groupe/groupe'
import HSEVisiteur from 'pages/visiteur/hse/hsevisiteur'
import ProjetsVisiteur from 'pages/visiteur/projets/projetsVisiteur'
import Urgences from 'pages/visiteur/urgence/urgences'
import Visiteur from 'pages/visiteur/visiteur'
import { useEffect, useState } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { getItem } from 'store/localeStorage'
import './styles/flex.scss'
import './styles/globals.scss'
import Astreintes from 'pages/salarie/astreintes/astreintes'
export default function Home() {
   const [affiche] = useSkaldElements('Affiche')
   const counterDefault = 600
   const [counter, setCounter] = useState(counterDefault)
   const [isOpen, setIsOpen] = useState(true)
   const [lang, setLang] = useState('fr')
   const timer = 300
   const [containerHeight, setContainerHeight] = useState('1660px')
   const [headband, setHeadband] = useState<headbandType>('')
   const [anchorButton, setAnchorButton] = useState<string[]>([])
   useEffect(() => {
      const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000)
      return () => clearInterval(timer)
   }, [counter])

   useEffect(() => {
      if (headband && document.getElementById('toto')) {
         setContainerHeight('1348px')
      } else if (headband === ' ') {
         setContainerHeight('1534px')
      } else if (headband) {
         setContainerHeight('1400px')
      } else {
         setContainerHeight('1660px')
      }
   }, [headband])
   useEffect(() => {
      console.log(counter)
      if (!isOpen || counter <= 0) {
         setCounter(counterDefault)
         setIsOpen(true)
      }
   }, [counter, timer])
   return (
      <div id='Layout' className='app'>
         {affiche.length > 0 ? (
            <div id='poster'>
               <img src={affiche[0].value} />
            </div>
         ) : (
            <HashRouter>
               <LangContext.Provider value={{ lang, setLang }}>
                  <HeadbandContext.Provider value={{ headband, setHeadband }}>
                     <AnchorButtonContext.Provider value={{ anchorButton, setAnchorButton }}>
                        <CounterContext.Provider value={{ counter, setCounter, counterDefault }}>
                           {counter < timer && isOpen && getItem('parcours') !== 'visiteur' && (
                              <PopupVeille onClose={() => setIsOpen(false)} />
                           )}

                           <Header setCounter={setCounter} />
                           {headband && <Headband />}
                           <div id='container' style={{ height: containerHeight }}>
                              <Routes>
                                 <Route
                                    path={
                                       getItem('parcours') === 'visiteur'
                                          ? '/accueil/visiteur/*'
                                          : '/accueil/*'
                                    }
                                 />
                                 <Route
                                    path='/'
                                    element={
                                       getItem('parcours') === 'visiteur' ? (
                                          <>
                                             <Visiteur />
                                          </>
                                       ) : (
                                          <Accueil />
                                       )
                                    }
                                 />
                                 {/* PARCOURS SALARIE */}
                                 <Route
                                    path='/accueil'
                                    element={
                                       getItem('parcours') === 'visiteur' ? (
                                          <>
                                             <Visiteur />
                                          </>
                                       ) : (
                                          <Accueil />
                                       )
                                    }
                                 />
                                 <Route
                                    path='/accueil/nosClientsNosProduits'
                                    element={<NosClientsNosProduits />}
                                 />
                                 <Route
                                    path='/accueil/autresInformations'
                                    element={<AutresInformations />}
                                 />
                                 <Route
                                    path='/accueil/informations'
                                    element={<VosInformationsRH />}
                                 />
                                 <Route path='/accueil/groupe' element={<Groupe />} />
                                 <Route path='/accueil/hse' element={<HSESalarie />} />
                                 <Route path='/accueil/qualite' element={<Qualité />} />
                                 <Route path='/accueil/moulage' element={<Moulage />} />
                                 <Route path='/accueil/siteNeubourg' element={<SiteNeubourg />} />
                                 <Route path='/accueil/urgence' element={<Urgence />} />
                                 <Route
                                    path='/accueil/visiteur/urgence'
                                    element={<Urgences visiteur />}
                                 />
                                 <Route path='/accueil/astreintes' element={<Astreintes />} />
                                 <Route path='/accueil/formulaire' element={<BoiteIdee />} />
                                 <Route path='/accueil/projets' element={<Projets />} />
                                 <Route path='/accueil/projets/archives' element={<Archives />} />

                                 {/* PARCOURS VISITEUR */}
                                 <Route
                                    path='/accueil/visiteur'
                                    element={
                                       <>
                                          <Visiteur />
                                       </>
                                    }
                                 />
                                 <Route
                                    path='/accueil/visiteur/groupe'
                                    element={<Groupe visiteur />}
                                 />
                                 <Route
                                    path='/accueil/visiteur/siteNeubourg'
                                    element={<SiteNeubourg visiteur />}
                                 />
                                 <Route path='/accueil/visiteur/hse' element={<HSEVisiteur />} />
                                 <Route
                                    path='/accueil/visiteur/gamme'
                                    element={<GammeProduits visiteur />}
                                 />
                                 <Route
                                    path='/accueil/visiteur/projets'
                                    element={<ProjetsVisiteur />}
                                 />
                                 <Route
                                    path='/accueil/visiteur/environnement'
                                    element={<Environnement visiteur />}
                                 />
                                 <Route
                                    path='/accueil/visiteur/qualite'
                                    element={<Qualité visiteur />}
                                 />
                              </Routes>
                           </div>
                           <Footer />
                        </CounterContext.Provider>
                     </AnchorButtonContext.Provider>
                  </HeadbandContext.Provider>
               </LangContext.Provider>
            </HashRouter>
         )}
      </div>
   )
}
